import { create } from "zustand";
import { GetBookingParams } from "~/services/booking";
import { TBooking } from "~/types/booking";
import { SortOrder } from "~/utils/constants";

export type FieldType = {
  clientId?: string;
  projectId?: string;
};
export type ViewMode = "edit" | "view";

interface BookingState {
  isOpen: boolean;
  bookingId?: string;
  booking?: TBooking;
  viewMode?: ViewMode;
  clientId?: string;
  filters?: GetBookingParams;
  infoForm: FieldType;
  isEstimateMode?: boolean;
}

interface BookingActions {
  toggleBooking: () => void;
  openBookingModal: ({
    bookingId,
    viewMode,
    isEstimateMode,
  }: {
    bookingId?: string;
    clientId?: string;
    viewMode?: ViewMode;
    isEstimateMode?: boolean;
  }) => void;
  closeBookingModal: () => void;
  setBooking: (booking?: TBooking) => void;
  setFilters: (filters: GetBookingParams) => void;
  setInfoForm: (infoForm: FieldType) => void;
  setClientId: (id: string) => void;
}

export const useBooking = create<BookingState & BookingActions>()((set) => ({
  clientId: "",
  isOpen: false,
  filters: {
    search: "",
    page: 1,
    pageSize: 10,
    sortByCreatedAt: SortOrder.DESC,
  },
  infoForm: {},
  setFilters: (filters) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
  toggleBooking: () => set((state) => ({ isOpen: !state.isOpen })),
  openBookingModal: ({ viewMode, bookingId, clientId, isEstimateMode }) =>
    set({ isOpen: true, bookingId, viewMode, clientId, isEstimateMode }),
  closeBookingModal: () =>
    set({
      isOpen: false,
      bookingId: undefined,
      viewMode: undefined,
      clientId: undefined,
      isEstimateMode: undefined,
    }),
  setBooking: (booking) => set({ booking }),
  setClientId: (id) => set({ clientId: id }),
  setInfoForm: (infoForm) =>
    set((state) => ({
      infoForm: {
        ...state.infoForm,
        ...infoForm,
      },
    })),
}));
